import { makeStyles } from '@material-ui/core/styles';
import Pagination from "@material-ui/lab/Pagination";
import { memo } from "react";
import { COLORS } from '../../../core/consts/redesign/commonRedesign';
import useIsMobile from '../../../core/hooks/useIsMobile';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: '40px',
    [theme.breakpoints.down(1024)]: {
      display: "flex",
      justifyContent: "center",
    }
  },
  pagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignSelf: 'flex-end',
    "& .MuiPaginationItem-page": {
      color: COLORS.black,
      border: `1px solid  ${COLORS.light_gray_stroke}`,
      height: "56px",
      width: "56px",
      gap: "10px",
      fontSize: "16px",
      fontFamily: "Gilroy",
      fontWeight: 600,
      '&.Mui-selected': {
        background: COLORS.brand_blue,
        color: COLORS.white,
      },
    },
    "& li:last-child .MuiPaginationItem-page": {
      width: "112px",
      background: COLORS.brand_blue,
      color: COLORS.white,
      '&.Mui-disabled': {
        background: COLORS.light_gray_bg,
        color: COLORS.gray2,
      },

    },
    // "& li:nth-last-child(2) .MuiPaginationItem-page": {
    //   display: 'none',
    // },
    "& li:last-child button::before": {
      content: "'дальше'",
    },
    "& li:last-child button:hover": {
      background: COLORS.light_blue,
    },
    "& .MuiPaginationItem-page .MuiPaginationItem-icon": {
      display: 'none',
    },
    [theme.breakpoints.down(1024)]: {
      width: '360px',
      height: '109px',
      flexDirection: 'row',
      flexWrap: 'wrap',
      display: "flex",
      justifyContent: 'center',
      "& .MuiPaginationItem-page": {
        width: "40px",
        height: "40px",
      },
      "& li:last-child": {
        flexBasis: '100%',
        order: -1,
        height: '56px',
        marginBottom: '16px',
        '& .MuiPaginationItem-page': {
          width: '100%',
          height: '56px'
        },
      },
    },
  }
}));

type PropsType = {
  currentPage: number;
  onPageChange: (event: React.ChangeEvent<unknown>, value: number) => void;
  itemsPerPage: number;
  totalItems: number,
}
const PaginationCustom = ({
  currentPage,
  onPageChange,
  itemsPerPage,
  totalItems
}: PropsType) => {
  const classes = useStyles();
  const isHidden = totalItems <= itemsPerPage;
  const isMobile = useIsMobile();
  const siblingCount = isMobile ? 1 : 2
  return (
    <div style={{ display: isHidden ? 'none' : 'block' }}>
      <Pagination
        count={Math.ceil(totalItems / itemsPerPage)}
        siblingCount={siblingCount}
        boundaryCount={1}
        page={currentPage}
        classes={{ root: classes.root, ul: classes.pagination }}
        onChange={(event, value) => onPageChange(event, value)}
        variant="outlined"
        shape="rounded"
        hidePrevButton
      />
    </div>
  )
}

export default memo(PaginationCustom)